import { readCookie, createCookie } from '../utils/helpers';
import { SubscribeCustomerToNewsletter } from '../utils/newsletter-subscribe';

const SubscribeForm = () => {
  const enableAJAX = true;
  const els = {
    cookiePolicyIsAccepted: readCookie('hide-cookie-policy'),
    hasVisitedSite: readCookie('visited'),
    subscribeForm: '#subscribe-form',
    subscribeFormClose: '#subscribe-form-close',
    subscribeFormTrigger: '#newsletter-button',
    subscribeFormHeading: '.subscribe-form__content-copy-heading',
    subscribeFormSubHeading: '.subscribe-form__content-copy-subheading',
    subscribeFormContent: '.subscribe-form__content-form',
    subscribeFormParent: '.subscribe-form__content-copy',
    dySubscribeForm: '#dy-subscribe-form',
    newsletterFormSelector: '#subscribe-form #newsletter_subscribe_form',
    dyNewsletterFormSelector:
      '#dy-subscribe-form #dy_newsletter_subscribe_form',
    emailInputSelector: 'input[name="contact[email]"]',
    genderDropdownSelector: 'select#Gender',
  };

  function initSubscribeForm() {    
    if (els.hasVisitedSite || els.hasVisitedSite === 'true') {
      fadeOutSubscribeForm();
    } else {
      createCookie('visited', 'true', 1);
    }   
  }

  function fadeInSubscribeForm() {
    $(els.subscribeForm).fadeIn().addClass('active');
  }
  function fadeOutSubscribeForm() {
    $(els.subscribeForm).removeClass('active').fadeOut();
  }

  if (document.querySelector(els.subscribeForm)) {
    if (document.querySelector(els.subscribeFormTrigger)) {
      document
        .querySelector(els.subscribeFormTrigger)
        .addEventListener('click', fadeInSubscribeForm);
    }
    if (document.querySelector(els.subscribeFormClose)) {
      document
        .querySelector(els.subscribeFormClose)
        .addEventListener('click', fadeOutSubscribeForm);
    }
    window.addEventListener('DOMContentLoaded', initSubscribeForm);
  }

  // =====================================
  // Shopify Newsletter Form
  // =====================================
  if (enableAJAX) {
    $(document).on('submit', els.newsletterFormSelector, (e) => {
      e.preventDefault();
      const SubscribeFormOptions = {
        $container: $(els.subscribeForm),
        $form: $(els.subscribeForm).find('form'),
        $emailInput: $(els.subscribeForm).find(els.emailInputSelector),
        $genderDropdown: $(els.subscribeForm).find(els.genderDropdownSelector),
        $formHeading: $(els.subscribeFormHeading),
        $formSubHeading: $(els.subscribeFormSubHeading),
        formID: $(els.subscribeForm).find('form').attr('id'),
        parentClass: els.subscribeFormParent,
        actionURL: $(els.subscribeForm).find('form').data('action-url'),
        successMsg:
          "<div class='subscribe-form__content-copy-success'><h3 class='note note--success'>Thanks! You have been successfully subscribed to our mailing list.</h3><p></p></div>",
      };
      SubscribeCustomerToNewsletter(SubscribeFormOptions);
      return false;
    });
  }

  // =====================================
  // DY Newsletter Form
  // =====================================
  if (enableAJAX) {
    $(document).on('submit', els.dyNewsletterFormSelector, (e) => {
      e.preventDefault();
      const DynamicYieldSubscribeFormOptions = {
        $container: $(els.dySubscribeForm),
        $form: $(els.dySubscribeForm).find('form'),
        $emailInput: $(els.dySubscribeForm).find(els.emailInputSelector),
        $genderDropdown: $(els.dySubscribeForm).find(
          els.genderDropdownSelector
        ),
        $formHeading: $(els.subscribeFormHeading),
        $formSubHeading: $(els.subscribeFormSubHeading),
        formID: $(els.dySubscribeForm).find('form').attr('id'),
        parentClass: els.subscribeFormParent,
        actionURL: $(els.dySubscribeForm).find('form').data('action-url'),
        successMsg:
          "<div class='subscribe-form__content-copy-success'><h3 class='note note--success'>Thanks! You have been successfully subscribed to our mailing list.</h3><p></p></div>",
      };
      SubscribeCustomerToNewsletter(DynamicYieldSubscribeFormOptions, true);
      return false;
    });
  }
};

export function triggerPopup(element, delay) {
  setTimeout(function () {
    $(element).fadeIn().addClass('active');
  }, delay);
}
export default SubscribeForm;
